import { useTranslation } from "react-i18next";

import { escapeHtml } from "./utils/escapeHtml.js";

export function ConfirmationStep({
  additionalContent = {},
  withdrawal,
  enableWithdrawalStatus,
  statusPath,
}) {
  const { t } = useTranslation();
  const message = t("proxy.withdrawals.confirmation.message_html", {
    email: escapeHtml(withdrawal.customer_email),
  });

  return (
    <div className="wp:mx-auto wp:max-w-xl">
      <div className="wp:mb-8 wp:rounded-md wp:border wp:border-solid wp:border-emerald-200 wp:bg-emerald-50 wp:p-4 wp:text-base wp:text-emerald-900">
        <strong className="wp:font-medium">{t("proxy.withdrawals.confirmation.success")}</strong>
      </div>
      <h1 className="wp:mb-6 wp:text-3xl wp:font-normal wp:tracking-tight wp:[color:var(--wf-text-color,#111827)] wp:md:text-4xl">
        {t("proxy.withdrawals.confirmation.title", { name: withdrawal.customer_name })}
      </h1>
      <p className="wp:mb-8 wp:text-lg wp:[color:var(--wf-text-color,#111827)]" dangerouslySetInnerHTML={{ __html: message }} />
      <div className="wp:mb-8 wp:rounded-md wp:border wp:border-solid wp:border-gray-200 wp:bg-gray-50 wp:p-6">
        <dl className="wp:grid wp:gap-6 wp:sm:grid-cols-2">
          <div className="wp:sm:col-span-2">
            <dt className="wp:text-sm wp:font-medium wp:text-gray-500">
              {t("proxy.withdrawals.common.fields.reference_number")}
            </dt>
            <dd className="wp:mt-1 wp:break-all wp:font-mono wp:text-base">{withdrawal.token}</dd>
          </div>
          <div>
            <dt className="wp:text-sm wp:font-medium wp:text-gray-500">
              {t("proxy.withdrawals.common.fields.submitted_at")}
            </dt>
            <dd className="wp:mt-1 wp:text-lg">{withdrawal.submitted_at_formatted}</dd>
          </div>
          {withdrawal.order_reference ? (
            <div>
              <dt className="wp:text-sm wp:font-medium wp:text-gray-500">
                {t("proxy.withdrawals.common.fields.order_number")}
              </dt>
              <dd className="wp:mt-1 wp:text-lg wp:[color:var(--wf-text-color,#111827)]">{withdrawal.order_reference}</dd>
            </div>
          ) : null}
        </dl>
      </div>
      <AdditionalContentBlock content={additionalContent.confirmation_page} />
      <a
        href="/"
        className="wp:flex wp:w-full wp:items-center wp:justify-center wp:rounded-md wp:border wp:border-solid wp:border-gray-300 wp:bg-white wp:px-6 wp:py-4 wp:text-lg wp:font-medium wp:text-gray-700 wp:no-underline wp:shadow-sm"
      >
        {t("proxy.withdrawals.common.actions.back_to_shop")}
      </a>
      {enableWithdrawalStatus ? (
        <a
          href={statusPath}
          className="wp:mt-4 wp:flex wp:w-full wp:items-center wp:justify-center wp:rounded-md wp:border wp:border-solid wp:border-gray-300 wp:bg-white wp:px-6 wp:py-4 wp:text-lg wp:font-medium wp:text-gray-700 wp:no-underline wp:shadow-sm"
        >
          {t("proxy.withdrawals.common.actions.check_status_later")}
        </a>
      ) : null}
    </div>
  );
}

function AdditionalContentBlock({ content }) {
  const text = String(content || "").trim();
  if (!text) return null;

  return (
    <div className="wp:mb-8 wp:whitespace-pre-wrap wp:text-base wp:leading-6 wp:text-gray-700">
      {text}
    </div>
  );
}
